<template>
	<div>
		<div class="supervisorRank" v-loading="allDoctorRankLoading">
			<div class="rankTop">
				<div class="rankTopLeft">
					<svg-icon class="fz18 marr4" icon-class='icon-Doctorsort'></svg-icon>
					<div class="inlin" v-if="DoctorsAvgScoreslist.length>0">
						<span class="marr4">{{DoctorsAvgScoreName.makeUp}}</span>
						<span @click="doctorSwipt">
							<svg-icon class="fz18 marr4" icon-class='icon-sort'></svg-icon>
						</span>
					</div>
					<div class="inlin" v-else>{{DoctorsAvgScoreName.makeUp}}(该时间段未抽样)</div>
				</div>
				<template v-if="DoctorsAvgScore.length>0">
					<div class="averageScore" v-if="HospitalAVGScoreBtn.average">
						<span>
							最高平均分：<b class="averageScoreOrganizationUp">{{DoctorsAvgScores.Max.AvgScore}}</b>分({{DoctorsAvgScores.Max.DoctorName}}-{{DoctorsAvgScores.Max.HospitalName}})</span>
						<span>
							最低平均分:<b class="averageScoreOrganizationDown">{{DoctorsAvgScores.Min.AvgScore}}</b>分({{DoctorsAvgScores.Min.DoctorName}}-{{DoctorsAvgScores.Min.HospitalName}})</span>

					</div>
				<!-- 	<div class="averageScore1" v-if="HospitalAVGScoreBtn.deduct">
						<span class="span">最多不合格<span v-if="HospitalAVGTypeName.name == 2">报告</span><span v-if="HospitalAVGTypeName.name == 3">影像</span>
							数量:<b class="averageScoreOrganizationDown">{{DoctorsAvgScores.Worst.ReportCount}}</b>份 ({{DoctorsAvgScores.Worst.DoctorName}})</span>
					</div> -->
				</template>
			</div>
			<div v-if="DoctorsAvgScore.length>0" class="mart10">
				<template v-if="HospitalAVGScoreBtn.average">
					<el-table class="qcTable qcHeight scrollbar" :data="DoctorsAvgScoreslist" height="471" :row-key="getDoctorskey"
					 @row-dblclick="changePie">
					  <!-- v-loading="tableloading" -->
						<el-table-column prop="TotalRank" label="排名" :key="1"></el-table-column>
						<el-table-column prop="DoctorName" label="姓名" :key="2"></el-table-column>
						<el-table-column prop="HospitalName" label="影像中心" :key="3">
							<template slot-scope="scope">
								{{scope.row.HospitalName }}
							</template>
						</el-table-column>
						<el-table-column prop="AvgScore" label="平均分" :key="4"></el-table-column>
						<el-table-column prop="QCedReportCount" label="质控数量(份)" :key="6"></el-table-column>
						<el-table-column prop="" label="操作" :key="5" width="180">
							<template slot-scope="scope">
								<span class="tableOpe" @click="qualifiedClick(scope.row,'qualified')">查看</span>
							</template>

						</el-table-column>
					</el-table>
				</template>
				<template v-if="HospitalAVGScoreBtn.deduct">
					<el-table class="qcTable qcHeight scrollbar" :data="DoctorsAvgScoreslist" height="400" :row-key="getRowKeys">
						<el-table-column prop="DoctorName" label="姓名" :key="11"></el-table-column>
						<el-table-column prop="HospitalName" label="影像中心" :key="12">
							<template slot-scope="scope">
								{{scope.row.HospitalName }}
							</template>
						</el-table-column>
						<el-table-column prop="ReportCount" label="份数" :key="13">
							<template slot-scope="scope">
								{{scope.row.ReportCount }}
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作" :key="14" width="180">
							<template slot-scope="scope">
								<span class="tableOpe" @click="qualifiedClick(scope.row,'unqualified')">查看</span>
							</template>

						</el-table-column>
					</el-table>
				</template>
				<div class="pages">
					<el-pagination class="pageAll" align="center" layout="prev, pager, next" :total="total" :page-size='DoctorsAvgScoreArr.pageCount'
					 :current-page='DoctorsAvgScoreArr.pageIndex' @current-change='currentChange'>
					</el-pagination>
				</div>
			</div>
			<div v-else class="echartsNull">
				<div>
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
			</div>
			<!-- v-if -->

		</div>
		<!-- supervisorRank-->
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import echarts from 'echarts'
	export default {
		data() {
			return {
				filtersz: [],
				recordExpands: '',
				expands: [],
				DoctorsAvgScoreslist: [],
				getRowKeys(row) {
					return row.DoctorGuid
				},
				getDoctorskey(row) {
					return row.DoctorGuid
				}
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['allDoctorRankLoading','DoctorsAvgScoreArr', 'total', 'InstitutionalRanking', 'DoctorsAvgScore', 'trigger',
				'DoctorsAvgScores', 'HospitalAVGScoreBtn', 'DoctorsAvgScoreName', 'HospitalAVGScoreArr', 'loading', 'tableloading',
				'doctorsAvgScorelist', 'HospitalAVGTypeName', 'doctorShowType', 'QualifiedPart', 'breadcrumbList', 'slider',
				'GetReportListArr',, 'setDateArr'
			]),
			triggersDoctor() {
				return this.trigger.doctor
			},
			DoctorsAvgScorecom() {
				return this.DoctorsAvgScore
			}
		},
		watch: {
			triggersDoctor(oldArr) {},
			DoctorsAvgScorecom(oldArr) {
				this.DoctorsAvgScoreslist = this.DoctorsAvgScore;
			}
		},
		updated() {
			if (this.trigger.doctor) {
				this.trigger.doctor = false;
				if (this.DoctorsAvgScore.length > 0) {
					//this.getEcharts()
				}
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow','skinPeeler']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'setSplitScreen', 'isRightPiemu', 'settableLoading',
				'setLoading', 'setqualifiedDoc', 'setBreadcrumbList', 'SummaryArr'
			]),
			...Vuex.mapMutations('doctor', ['setDetailsParameter']),
			...Vuex.mapActions('supervisor', ['GetDoctorsAvgScore', 'GetDoctorUnqualifiedReport', 'GetReportList', 'ReportList',
				'GetSummary'
			]),
			...Vuex.mapActions('doctor', ['GetReportDetail']),
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}
			},
			expandSelect(row, expandedRows) {
				this.gotoSeccend(row)
			},
			reportImg(row) {
				this.setSplitScreen(1);
				this.setDetailsParameter({
					reportGuid: row.ReportGuid,
					samplingTaskGuid: row.SamplingTaskGuid
				})
				this.GetReportDetail()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			handdle(row) {
				// this.doctorsAvgScorelist.children = [];
				this.gotoSeccend(row)
				this.setLoading(true)
			},
			changePie(row) {
				this.GetSummary({
					doctorGuid: row.DoctorGuid,
					doctorName: row.DoctorName,
					hospitalGuid: row.HospitalGuid
				});
			},
			gotoSeccend(row) {
				this.recordExpands = row.DoctorGuid;
				this.setLoading(true);
				this.isRightPiemu(false);
				if (this.expands[0] != this.recordExpands) {
					this.expands = []

					this.expands.push(row.DoctorGuid);

				} else {
					this.expands = []
				}
				this.hospitalGuid = ''
				this.GetReportList({
					hospitalGuid: row.HospitalGuid,
					doctorName: row.DoctorName,
					isUnqualified: true,
				});
			},
			filterTagTable(filters) {
				let hospitalGuid = [];
				if (filters.hospitalGuid) {
					hospitalGuid = filters.hospitalGuid.join(',')
				}
				this.hospitalGuid = hospitalGuid
				this.GetReportList({
					hospitalGuid: row.HospitalGuid,
					doctorName: row.DoctorName,
					isUnqualified: true
				});
				this.expands = []
				this.expands.push(this.recordExpands)
			},
			// 分页
			currentChange(val) {
				this.DoctorsAvgScoreArr.pageIndex = val;
				this.defaultGet();
			},
			//合格医生点击
			qualifiedClick(row, type) {
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.QualifiedPart.hospitalGuid = row.HospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
				this.breadcrumbList.push(row.DoctorName);
				this.$router.push("/home/supervisor/qualifiedTable");
				this.breadcrumbList.push("doctor");
			},
			//不合格医生点击
			handleClick(datas) {
				this.setSplitScreen(1);
				this.setDetailsParameter({
					reportGuid: datas.ReportGuid,
					samplingTaskGuid: datas.SamplingTaskGuid
				})
				this.GetReportDetail()
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			doctorSwipt() {
				//医生排名状态
				this.InstitutionalRanking.type = 2;
				let sortType = this.HospitalAVGScoreArr.sortType == 2 ? 1 : 2;
				this.HospitalAVGScoreArr.sortType = sortType;
				this.defaultGet()
			},
			defaultGet() {
				this.settableLoading(true);
				if (this.HospitalAVGScoreBtn.average) {
					this.GetDoctorsAvgScore();
				}
				if (this.HospitalAVGScoreBtn.deduct) {
					this.GetDoctorUnqualifiedReport();
				}
			},
			getEcharts() {
				let dom = document.getElementById("container1");
				let myChart = echarts.init(dom);
				let data = [];
				let value = [];
				let color = ['#1e88e5'];
				if (this.DoctorsAvgScore.length > 0) {
					if (this.HospitalAVGScoreBtn.average) {
						color = ['#1e88e5'];
						this.DoctorsAvgScore.forEach(element => {
							data.push(element.DoctorName)
							value.push(element.AvgScore)
						})
					}
					if (this.HospitalAVGScoreBtn.deduct) {
						color = ['#ce71e3'];
						this.DoctorsAvgScore.forEach(element => {
							data.push(element.DoctorName)
							value.push(element.ReportCount)
						})
					}

				}
				let option = null;

				option = {
					color: color,

					grid: {
						top: 0,
						left: '0%',
						right: '2%',
						bottom: '0%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						//boundaryGap: [0, 0.01],
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'category',
						data: data,
						triggerEvent: true,
						axisTick: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							show: false
						}
					},
					series: [

						{
							name: '医生排名',
							type: 'bar',
							barMaxWidth: 15,
							label: {
								show: true
							},
							data: value
						}
					]
				};
				if (option && typeof option === "object") {
					myChart.clear();
					myChart.setOption(option, true);
					myChart.off('click'); //清除联系点击
					myChart.on('click', (params) => {
						let name = params.name == undefined ? params.value : params.name;
						let arr = {}
						this.DoctorsAvgScore.forEach(res => {
							if (res.DoctorName == name) {
								arr = res;
							}
						})
						if (arr.DoctorName) {
							this.setPoints(arr.HospitalGuid, arr.DoctorName)
						}
					})
				}
			},
		}

	}
</script>
